import { easeOut, TargetAndTransition, Transition } from 'framer-motion';

// utils/animationConfig.ts
type BaseAnimation = {
  initial: TargetAndTransition;
  animate: TargetAndTransition;
  exit: TargetAndTransition;
  transition: Transition;
};

export const expandCollapseAnimation: BaseAnimation = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
  transition: {
    duration: 0.5,
    ease: 'easeInOut',
  },
};

export const slideInRight: BaseAnimation = {
  initial: { opacity: 0, height: 0, x: 200 },
  animate: { opacity: 1, height: 'auto', x: 0 },
  exit: { opacity: 0, height: 0, x: 200 },
  transition: {
    duration: 0.25,
    ease: 'easeInOut',
  },
};

export const slideInLeft: BaseAnimation = {
  initial: { opacity: 0, height: 0, x: -200 },
  animate: { opacity: 1, height: 'auto', x: 0 },
  exit: { opacity: 0, height: 0, x: -200 },
  transition: {
    duration: 0.25,
    ease: 'easeInOut',
  },
};

export const formSliderVariants = {
  incoming: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
    scale: 1.02,
    opacity: 0,
  }),
  active: { x: 0, scale: 1, opacity: 1 },
  exit: (direction: number) => ({
    x: direction > 0 ? '-100%' : '100%',
    scale: 0.998,
    opacity: 0,
  }),
};

export const disclosurePanelAnimation: BaseAnimation = {
  initial: { opacity: 0, y: -12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -12 },
  transition: {
    duration: 0.12,
    ease: easeOut,
  },
};

/** Staggered fade-up for list/grid items (e.g. chooser cards). */
export const staggeredFadeUpAnimation = (index: number): BaseAnimation => ({
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 4 },
  transition: {
    delay: index * 0.03,
    duration: 0.2,
    ease: [0.4, 0, 0.2, 1],
  },
});

export const expandCollapseFastAnimation: BaseAnimation = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
  transition: {
    duration: 0.2,
    ease: 'easeInOut',
  },
};
